import TrackingApi from "@shared/_api/tracking";

export default class PageTracker {
    constructor() {
        this.pageView = {
            url : null,
            label : null,
            type: 'DEFAULT'
        }
    }

    trackView(pageData, user) {
        Object.assign(this.pageView, pageData);
        TrackingApi.postPageVisit(this.pageView, user);
    }

    trackEvent(event) {
        TrackingApi.postEvent(event);
    }

    updatePath(newPath) {
        Object.assign(this.pageView, {url: newPath});
    }
}